// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "privacy_erasure_log".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "privacy_erasure_log" table (1:1 with a DB row, on the wire). */
export const privacyErasureLogAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    subjectType: z.string(),
    subjectId: z.string(),
    contactHash: z.string().nullable(),
    counts: z.unknown(),
    erasedAt: z.string().datetime(),
    externalJobsCompletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=privacyErasureLog.js.map